<template>
    <div id="app">
        <div v-if="loading" class="ls-app--initial-load">
            Loading...
        </div>
        <RouterView v-else />
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'App',
    computed: {
        loading() {
            return _.isNull(this.$route.name);
        },
    },
};
</script>

<style lang="scss">
@import '@/scss/main.scss';

.ls-app--initial-load {
    display: grid;
    place-items: center;
    height: 100vh;
    font-size: 25px;
    color: #3c4368;
    font-weight: $semi-bold;
}
</style>
